import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import config from "./config";

const APIUrl = config.API_BASE_URL + "/register";

// ─── Design tokens ────────────────────────────────────────────────────────────
const C = {
  bg:     "#08101e",
  bg1:    "#0c1525",
  border: "#1e2d42",
  text:   "#e8edf5",
  body:   "#b8c8dc",
  meta:   "#6a7d95",
  green:  "#00e896",
  cyan:   "#00c8ff",
  red:    "#ff4466",
};
const FONT = "'DM Mono', monospace";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Mono:wght@300;400;500&display=swap');
  * { box-sizing: border-box; }
  .reg-input {
    width: 100%;
    background: ${C.bg};
    border: 1px solid ${C.border};
    color: ${C.text};
    font-family: ${FONT};
    font-size: 12px;
    padding: 10px 14px;
    border-radius: 4px;
    outline: none;
    transition: border-color .15s;
    letter-spacing: .3px;
  }
  .reg-input:focus { border-color: ${C.cyan}; }
  .reg-input::placeholder { color: ${C.meta}; }
  .reg-input:disabled { opacity: 0.5; cursor: not-allowed; }
  .reg-btn {
    width: 100%;
    padding: 11px;
    background: ${C.green}15;
    border: 1px solid ${C.green}40;
    color: ${C.green};
    font-family: ${FONT};
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 1.2px;
    border-radius: 4px;
    cursor: pointer;
    transition: background .15s, border-color .15s;
  }
  .reg-btn:hover:not(:disabled) {
    background: ${C.green}25;
    border-color: ${C.green}70;
  }
  .reg-btn:disabled { opacity: 0.5; cursor: not-allowed; }
  @keyframes orbPulse {
    0%,100% { transform: scale(1); opacity: .15; }
    50%      { transform: scale(3); opacity: 0; }
  }
`;

const Orb = ({ color, size = 8, speed = "3s" }) => (
<div style={{ position:"relative", width:size, height:size, flexShrink:0 }}>
<div style={{ position:"absolute", inset:0, borderRadius:"50%", background:color, animation:`orbPulse ${speed} ease-in-out infinite` }} />
<div style={{ position:"absolute", inset:"25%", borderRadius:"50%", background:color }} />
</div>
);

const Field = ({ label, children }) => (
<div style={{ marginBottom:16 }}>
<label style={{ display:"block", fontFamily:FONT, fontSize:9, color:C.meta,
    letterSpacing:"1px", textTransform:"uppercase", marginBottom:6 }}>
{label}
</label>
{children}
</div>
);

const Register = (props) => {
  const [name,            setName]            = useState("");
  const [email,           setEmail]           = useState("");
  const [username,        setUsername]        = useState("");
  const [password,        setPassword]        = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage,    setErrorMessage]    = useState(null);
  const [successMessage,  setSuccessMessage]  = useState(null);
  const [loading,         setLoading]         = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim() || !email.trim() || !username.trim() || !password.trim()) {
      setErrorMessage("All fields are required");
      return;
    }
    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match");
      return;
    }
    if (password.length < 6) {
      setErrorMessage("Password must be at least 6 characters");
      return;
    }
    setErrorMessage(null);
    setLoading(true);
    axios.post(APIUrl,
        { name: name.trim(), email: email.trim(), username: username.trim(), password },
        { headers: { "x-api-key": config.API_KEY } }
        )
        .then(() => {
          setSuccessMessage("Account created. Redirecting to sign in...");
          setTimeout(() => props.history.push("/Login"), 1800);
        })
        .catch((error) => {
          setLoading(false);
          if (error.response?.status === 401) {
            setErrorMessage(error.response.data?.message || "Registration failed");
          } else {
            setErrorMessage("Server error — please try again later");
          }
        });
  };

  return (
      <div style={{
    background:     C.bg,
        minHeight:      "100vh",
        display:        "flex",
        alignItems:     "center",
        justifyContent: "center",
        padding:        "20px",
        fontFamily:     FONT,
  }}>
  <style>{CSS}</style>

  <div style={{ width:"100%", maxWidth:360 }}>

  {/* ── Brand mark ─────────────────────────────────────────────────── */}
  <div style={{ textAlign:"center", marginBottom:32 }}>
  <div style={{ display:"flex", justifyContent:"center", marginBottom:16 }}>
  <Orb color={C.green} size={10} speed="2.5s" />
      </div>
      <div style={{ fontFamily:FONT, fontWeight:500, fontSize:14, color:C.text, letterSpacing:"2px", marginBottom:6 }}>
  BERBUL.AI
  </div>
  <div style={{ fontFamily:FONT, fontSize:9, color:C.meta, letterSpacing:"1px" }}>
  AUTONOMOUS TRADING · SPY 0DTE
  </div>
  </div>

  {/* ── Card ───────────────────────────────────────────────────────── */}
  <div style={{
    background:   C.bg1,
        border:       `1px solid ${C.border}`,
        borderRadius: 12,
        padding:      "32px 32px 28px",
  }}>

  {/* Card header */}
  <div style={{ marginBottom:24 }}>
  <div style={{ fontFamily:FONT, fontSize:9, color:C.meta, letterSpacing:"1.5px", textTransform:"uppercase", marginBottom:6 }}>
  Create account
  </div>
  <div style={{ fontFamily:FONT, fontSize:11, color:C.body, fontWeight:300 }}>
  Join BerBul and start following the bot
  </div>
  </div>

  <Field label="Full Name">
      <input className="reg-input" type="text" value={name}
  onChange={e => setName(e.target.value)} disabled={loading}
  placeholder="your name" autoComplete="name" />
      </Field>

      <Field label="Email">
      <input className="reg-input" type="email" value={email}
  onChange={e => setEmail(e.target.value)} disabled={loading}
  placeholder="you@example.com" autoComplete="email" />
      </Field>

      <Field label="Username">
      <input className="reg-input" type="text" value={username}
  onChange={e => setUsername(e.target.value)} disabled={loading}
  placeholder="choose a username" autoComplete="username" />
      </Field>

      <Field label="Password">
      <input className="reg-input" type="password" value={password}
  onChange={e => setPassword(e.target.value)} disabled={loading}
  placeholder="min 6 characters" autoComplete="new-password" />
      </Field>

      <Field label="Confirm Password">
      <input className="reg-input" type="password" value={confirmPassword}
  onChange={e => setConfirmPassword(e.target.value)} disabled={loading}
  placeholder="repeat password" autoComplete="new-password"
  onKeyDown={e => e.key === "Enter" && handleSubmit(e)} />
  </Field>

  {/* Error */}
  {errorMessage && (
  <div style={{
    background: C.red + "12", border: `1px solid ${C.red}30`,
        borderRadius:4, padding:"9px 12px", marginBottom:16,
        display:"flex", alignItems:"center", gap:8,
  }}>
  <div style={{ width:5, height:5, borderRadius:"50%", background:C.red, flexShrink:0 }} />
  <span style={{ fontFamily:FONT, fontSize:10, color:C.red }}>{errorMessage}</span>
  </div>
  )}

  {/* Success */}
  {successMessage && (
  <div style={{
    background: C.green + "12", border: `1px solid ${C.green}30`,
        borderRadius:4, padding:"9px 12px", marginBottom:16,
        display:"flex", alignItems:"center", gap:8,
  }}>
  <div style={{ width:5, height:5, borderRadius:"50%", background:C.green, flexShrink:0 }} />
  <span style={{ fontFamily:FONT, fontSize:10, color:C.green }}>{successMessage}</span>
  </div>
  )}

  {/* Submit */}
  <button className="reg-btn" onClick={handleSubmit} disabled={loading || !!successMessage}>
  {loading ? "CREATING ACCOUNT..." : "CREATE ACCOUNT"}
  </button>

  {/* Sign in link */}
  <div style={{ marginTop:20, textAlign:"center" }}>
  <span style={{ fontFamily:FONT, fontSize:10, color:C.meta }}>Already have an account?{" "}</span>
  <Link to="/Login" style={{ fontFamily:FONT, fontSize:10, color:C.cyan, textDecoration:"none", fontWeight:500 }}>
  Sign in →
  </Link>
  </div>

  </div>
  </div>
  </div>
  );
};

export default Register;